import { Box } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Html5QrcodeSupportedFormats } from "html5-qrcode";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import both_icon from "../../template/images/both_icon.svg";
import delf_icon from "../../template/images/delf_icon.svg";
import InputElement from "../../util/InputElement";
import SelectElement from "../../util/SelectElement";
import { ValidationPattern } from "../../util/ValidationPattern";
import {
  fetchOccupations,
  fetchSingleEvent,
  registerEXUser,
  registerUser,
} from "../../util/axiosConfig/api/api";
import { uploadedDocs } from "../../util/master";
import Loader from "../../util/preloader/Preloader";
// import { uspTemData } from './../../util/master';
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import { downloadQr, validateEmail } from "../../services/ApiCaller/Registration";
import { ENV } from "../../util/Env";
import Eventscard from "../home/Eventscard";
import QRScanner from "../layout/QRScanner";
import { decryptWithSpaces } from "../../util/DecryptWithSpaces";


const Registration = () => {
  let { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [mandatory, setMandatory] = useState(true);
  const [uspTemData, setuspTemData] = useState([]);
  const [selectedDateerrors, setselectedDateerrors] = useState(false);
  const [showScannerModal, setShowScannerModal] = useState(false);
  const [valuedayjs, setValuedayjs] = useState(null);
  const [selectedTab, setSelectedTab] = useState("NewRegistered");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalActive, setConfirmationModalActive] = useState(false);
  const [show, setShow] = useState(false);

  const [triggerModal, setTriggerModal] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState(false);
  const [gender, setGender] = useState("");
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [emailExists, setEmailExists] = useState(null);
  const [emailExistsValue, setEmailExistsValue] = useState();

  const handleEventType = (tabName) => {
    setSelectedTab(tabName);
    // handleEventDetails(tabName);
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    trigger,
    control,
    watch,
    getValues,
  } = useForm();

  const useFromProps = {
    register,
    errors,
    setValue,
    trigger,
    control,
    watch,
    getValues,
  };

  const [openQr, setOpenQr] = useState(false);

  const [occupationsList, setOccupationsList] = useState([]);
  const [occupationId, setOccupationId] = useState("");
  const [occupation, setOccupation] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const resposnse = fetchSingleEvent(id);
    resposnse.then(
      async (success) => {
        setLoading(false);

        if (success && success.trainerName) {
          try {
            const decryptedName = await decryptWithSpaces(success.trainerName);
            setuspTemData({ ...success, trainerName: decryptedName });
          } catch (e) {
            setuspTemData(success);
          }
        } else {
          setuspTemData(success);
        }
      },
      (error) => {
        setLoading(false);

        swal({
          text: !error.data.message
            ? "We are temporarily experiencing technical difficulties. Please try again after sometime "
            : error.data.message,
          icon: "error",
          button: "OK",
        }).then((value) => {
          if (value === true) {
            navigate(`/`);
          }
        });
      }
    );
  }, []);

    useEffect(() => {
    const fetchOccupationlist = async () => {
      const response = await fetchOccupations();
      const fetchedList = Object.values(response).map((item) => ({
        label: item.occupationLebel,
        value: item.occupation,
      }));

      setOccupationsList([{ label: 'Select', value: null }, ...fetchedList]);
    };

    fetchOccupationlist();
  }, []);


    // const fetchOccupationlist = async () => {
    //   setOccupationsList([{ label: 'Select Occupation', value: null }]);
      
    //   const response = fetchOccupations();
  
    //   response.then((success) => {
    //     const fetchedList = Object.values(success).map((item) => ({
    //       label: item.occupationLebel,
    //       value: item.occupation,
    //     }));
    //     setOccupationsList((prevData) => [...prevData, ...fetchedList]);
    //   });
    // };

  const getNameParts = (fullName) => {
    const nameArray = fullName.trim().split(/\s+/);
    return {
      firstName: nameArray[0] || "",
      lastName: nameArray.length > 1 ? nameArray[nameArray.length - 1] : "",
      middleName: nameArray.length > 2 ? nameArray.slice(1, -1).join(" ") : "",
    };
  };

  const handlemodal = () => {
    setShowScannerModal(true);
    setOpenQr(!openQr);
  };
  const handleClose = () => {
    setOpenQr(!openQr);
    setShowScannerModal(false);
    // localStorage.removeItem("HTML5_QRCODE_DATA")
  };
  // const handleScanner = () => {
  //   // localStorage.removeItem("HTML5_QRCODE_DATA")
  //   setShowScannerModal(true)
  // }
  const formatsToSupport = [
    Html5QrcodeSupportedFormats.QR_CODE,
    Html5QrcodeSupportedFormats.UPC_A,
    Html5QrcodeSupportedFormats.UPC_E,
    Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
  ];
  // const [decodedResults, setDecodedResults] = useState([]);
  // let isWaitingForResponse = false;
  // const onNewScanResult = (decodedText, decodedResult) => {

  //   if (isWaitingForResponse) {
  //     console.log("Still waiting for the previous scan...");
  //     return;
  //   }

  //   isWaitingForResponse = true;

  //   console.log(`Message: ${decodedText}, Result: ${JSON.stringify(decodedResult)}`);
  //   setTimeout(() => {
  //     setShowScannerModal(false)
  //     localStorage.removeItem("HTML5_QRCODE_DATA")
  //   }, 500);

  //   const Data = JSON.stringify({
  //     "qr": decodedText,
  //   });

  //   // Set a timeout to allow the next scan
  //   setTimeout(() => {
  //     isWaitingForResponse = false;
  //   }, 5000); // 5000ms = 5 seconds, adjust as needed
  //   const resp = downloadQr(Data);
  //   resp.then(
  //     (success) => {

  //       if (!success) {
  //         swal({
  //           title: "try",

  //           icon: "error",
  //           backdrop: false,
  //           allowOutsideClick: false,
  //           showCloseButton: true,
  //           allowOutsideClick: true,
  //           showCloseButton: true,
  //           closeOnClickOutside: false,
  //           showCancelButton: true,
  //           focusConfirm: true,

  //         });
  //       } if (success) {
  //         swal({
  //           title: "Scan Successful",

  //           icon: "success",
  //           backdrop: false,
  //           allowOutsideClick: false,
  //           showCloseButton: true,
  //           allowOutsideClick: true,
  //           showCloseButton: true,
  //           closeOnClickOutside: false,
  //           showCancelButton: true,
  //           focusConfirm: true,

  //         });
  //         setValue("ParticipantName", success.name )
  //         setName(success.name)
  //         setValue("Mobile", success.mobile )
  //         setMobile(success.mobile)
  //         setValue("Email", success.email )
  //         setEmail(success.email)
  //         setValue("Gender", success.gender)
  //         setValue("Pincode", success.address)
  //         setDob(success.dob)
  //         setValuedayjs(success.dob)
  //         setValue("selectedDate", success.dob)
  //         setGender(success.gender)
  //         setValue("Gender", success.gender === "M" ? "Male" : "Female" )

  //       }
  //     },
  //     (error) => {
  //       console.log("error", error);
  //       swal({
  //         title: error.data?.message ? error.data?.message : "Please ensure upload the correct QR code, for authenticity",
  //         // content: error.data.message,
  //         // html: true,
  //         icon: "error",
  //         backdrop: false,
  //         allowOutsideClick: false,
  //         showCloseButton: true,
  //         allowOutsideClick: true,
  //         showCloseButton: true,
  //         closeOnClickOutside: false,
  //         showCancelButton: true,
  //         focusConfirm: true,

  //       })
  //     }
  //   );
  // };

  // const qrCodeErrorCallback = (errorMessage) => {
  //   console.log(errorMessage);
  //   document.getElementById("html5qr-code-full-region__header_message").innerHTML = "";
  //   document.getElementById("html5qr-code-full-region__header_message").innerHTML = "File should be in QR format "
  // };

  let divClassName = " col-12 ";
  let divClassNameSelectElement = " col-6 ";
  // const onSubmit = (data) => {
  //   setLoading(true);
  //   var nameArray = data.ParticipantName.split(/\s+/);
  //   const Data = JSON.stringify({
  //     firstName: nameArray[0],
  //     lastName:
  //       nameArray.length > 2
  //         ? nameArray[2]
  //         : nameArray.length > 1
  //         ? nameArray[1]
  //         : "",
  //     middleName: nameArray.length > 2 ? nameArray[1] : "",
  //     studentEmail: data.Email,
  //     studentMobileNumber: data.Mobile,
  //     selfRegistered: true,
  //     studentDOB: valuedayjs,
  //     pincode: data.PINcode,
  //     gender:
  //       gender === ""
  //         ? data.Gender.value
  //         : gender === "M"
  //         ? uploadedDocs[0].value
  //         : uploadedDocs[1].value,
  //     // gender: data.Gender.value
  //   });
  //   console.log("data to be submitted", data);

  //   const resposnse = registerUser(id, Data);

  //   resposnse.then(
  //     (success) => {
  //       swal({
  //         text: `You have been successfully registered for the event.Check your Email & WhatsApp for details`,
  //         icon: "success",
  //         button: "OK",
  //       }).then((value) => {
  //         if (value === true) {
  //           navigate(`/`);
  //         }

  //       });

  //       if (success) {
  //         setLoading(false);
  //       }
  //     },
  //     (error) => {
  //       setLoading(false);
  //       swal({
  //         text: !error.data.message
  //           ? "We are temporarily experiencing technical difficulties. Please try again after sometime "
  //           : error.data.message,
  //         icon: "error",
  //         button: "OK",
  //       }).then((value) => {
  //         // if (value === true) {
  //         //   navigate(`/`)
  //         // }
  //       });
  //     }
  //   );
  // };
  const onSubmit = async (data) => {
    setLoading(true);
    // const formattedDOB = valuedayjs ? valuedayjs.format("YYYY-MM-DD") : null;
    // var nameArray = data.ParticipantName.split(/\s+/);
    const formattedDOB = valuedayjs ? valuedayjs.format("YYYY-MM-DD") : null;
    const { firstName, middleName, lastName } = getNameParts(data.ParticipantName);
    const Data = JSON.stringify({
      // firstName: nameArray[0],
      // lastName:
      //   nameArray.length > 2
      //     ? nameArray[2]
      //     : nameArray.length > 1
      //       ? nameArray[1]
      //       : "",
      // middleName: nameArray.length > 2 ? nameArray[1] : "",
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      studentEmail: data.Email,
      studentMobileNumber: data.Mobile,
      selfRegistered: true,
      // studentDOB: valuedayjs,
      // studentDOB: formattedDOB,
      age: parseInt(data.age, 10),
      // occupation: data.occupation,
      occupation: data.occupation ? data.occupation.value : null,
      studentDOB: formattedDOB,
      pincode: data.PINcode,
      gender:
        gender === ""
          ? data.Gender.value
          : gender === "M"
            ? uploadedDocs[0].value
            : uploadedDocs[1].value,
      // gender: data.Gender.value
      disclaimer: data.disclaimer,
    });
    try {
      setConfirmationMsg(true);
      const fileRes = await registerUser(id, Data);
      setConfirmationMsg(true);

      swal({
        // text: `You have been successfully registered for the event. Check your Email for details.`,
        text: `${fileRes.responseMessage}`,
        icon: "success",
        button: "OK",
      }).then((value) => {
        if (value === true) {
           reset({
                Email: "",
                ParticipantName: "",
                Mobile: "",
                Gender: "",
                PINcode: "",
                age: "",
                occupation: null,
                selectedDate: null, // for date
              });
          // navigate(`/`);
        }
      });
      setLoading(false);
      setConfirmationMsg(false);
    } catch (error) {
      swal({
        text: !error.data.message
          ? "We are temporarily experiencing technical difficulties. Please try again after sometime "
          : error.data.message,
        icon: "error",
        button: "OK",
      }).then((value) => {
        if (value === true) {
          reset({
              Email: "",
              ParticipantName: "",
              Mobile: "",
              Gender: "",
              Pincode: "",
              selectedDate: null, // for date
            });
        }
      });
      setLoading(false);
      setConfirmationMsg(false);
    }
  };
  const regonSubmit = (data) => {

    const regEmail = typeof data === "string" ? data : data?.RegEmail;

    // window.open(`${ENV.API_KEY_URL_BEN}/beneficiary-app`,'_blank', )

    // navigate()
    //alert("ss")
    // var nameArray = data.ParticipantName.split(/\s+/);
    const Data = JSON.stringify({
      // studentEmail: data.RegEmail,
      studentEmail: regEmail,
    });
    // console.log("data to be submitted", data);

    // Use fetch for API calling as requested
    setLoading(true);
    fetch(ENV.API_URL+`web/api/v1/lms-web/website/registerUserIfExist/${id}`, {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: Data,
    })
      .then(async (response) => {
        let payload = null;
        try {
          payload = await response.json();
        } catch (_) {
          payload = null;
        }
        if (!response.ok) {
          throw { data: { message: payload?.message || payload?.responseMessage } };
        }
        return payload;
      })
      .then((success) => {
        swal({
          text: `${success?.responseMessage ?? "You have been successfully registered for the event."}`,
          icon: "success",
          button: "OK",
        }).then((value) => {
          if (value === true) {
            reset({
              Email: "",
              ParticipantName: "",
              Mobile: "",
              Gender: "",
              PINcode: "",
              age: "",
              occupation: null,
              selectedDate: null, // for date
            });
          }
          // Keep preloader visible until after user closes success popup
        });
        // Hide preloader once success popup is shown
        setLoading(false);
      })
      .catch((error) => {
        swal({
          text: !error?.data?.message
            ? "We are temporarily experiencing technical difficulties. Please try again after sometime "
            : error?.data?.message,
          icon: "error",
          button: "OK",
        }).then((value) => {
          if (value === true) {
            setEmail("");
            setValue("Email", "");
          }
        });
        // Hide preloader once error popup is shown
        setLoading(false);
      });
  };

  const isInvalidDateData = (data) => {
    return data === null || data == "Invalid Date";
  };

  const validateDateWithMinMax = (data, x, y) => {
    return moment(data.$d).diff(x, "days") < 0 || moment(data.$d).diff(y, "days") > 0;
  };

  const validateDateWithMinOnly = (data) => {
    return moment().subtract(24, "hours").diff(data.$d) <= 0 || moment().diff(moment(data.$d), "years", true) > 99;
  };

  const validateDateWithMaxOnly = (data) => {
    return moment().add(15, "days").diff(data.$d) > 0 || moment(data.$d).diff(moment(), "years", true) > 99;
  };

  const daterval = (data, x, y, type, max, min) => {
    let temdate = false;

    if (isInvalidDateData(data)) {
      temdate = true;
    } else if (data.$d == "Invalid Date") {
      temdate = true;
    } else if (max === "maxDate" && min === "minDate") {
      temdate = validateDateWithMinMax(data, x, y);
    } else if (min === "minDate") {
      temdate = validateDateWithMinOnly(data);
    } else if (max === "maxDate") {
      temdate = validateDateWithMaxOnly(data);
    }

    if (type === "DOB") {
      setselectedDateerrors(temdate);
    }
  };
  const qrCodeSuccessCallback = (decodedText) => {
    const Data = JSON.stringify({
      qr: decodedText,
    });

    const resp = downloadQr(Data);
    resp.then(
      (success) => {
        if (!success) {
          swal({
            title: "try",
            icon: "error",
            backdrop: false,
            allowOutsideClick: false,
            showCloseButton: true,
            allowOutsideClick: true,
            showCloseButton: true,
            closeOnClickOutside: false,
            showCancelButton: true,
            focusConfirm: true,
          });
        }
        if (success) {
          swal({
            title: "Scan Successful",
            icon: "success",
            backdrop: false,
            allowOutsideClick: false,
            showCloseButton: true,
            allowOutsideClick: true,
            showCloseButton: true,
            closeOnClickOutside: false,
            showCancelButton: true,
            focusConfirm: true,
          });
          setValue("ParticipantName", success.name);
          setName(success.name);
          setValue("Mobile", success.mobile);
          setMobile(success.mobile);
          setValue("Email", success.email);
          setEmail(success.email);
          setValue("Gender", success.gender);
          setValue("Pincode", success.address);
          setDob(success.dob);
          setValuedayjs(success.dob);
          setValue("selectedDate", success.dob);
          setGender(success.gender);
          setValue("Gender", success.gender === "M" ? "Male" : "Female");
        }
      },
      (error) => {
        console.log("error", error);
        swal({
          title: error.data?.message
            ? error.data?.message
            : "Please ensure upload the correct QR code, for authenticity",
          // content: error.data.message,
          // html: true,
          icon: "error",
          backdrop: false,
          allowOutsideClick: false,
          showCloseButton: true,
          allowOutsideClick: true,
          showCloseButton: true,
          closeOnClickOutside: false,
          showCancelButton: true,
          focusConfirm: true,
        });
      }
    );
  };


//   const handleEmailValidation = (e) => {
//   const emailVal = e.target.value.trim();
//   if (ValidationPattern.email.test(emailVal)) {
//     validateEmail(emailVal)
//       .then((exists) => {
//         if (exists === true)
//           swal({
//             text: `The email ${emailVal} is already registered in our system. Would you like to Use the existing data on system or Register again with new details.`,
//             icon: "warning",
//             closeOnClickOutside: false,
//             buttons: {
//               cancel: "Enter New Details",
//               confirm: "Use Existing Data",
//             },
//           }).then((res) => {
//             if (res) {
//               regonSubmit(emailVal);
//               setEmail("");
//               setValue("Email", "");
//             } else {  
//               setEmail("");
//               setValue("Email", "");
//               setEmailExists(null);
//             }
//           });
//         setEmailExists(exists);
//       })
//       .catch(() => {
//         setEmailExists(null);
//       });
//   } else {
//     setEmailExists(null);
//   }
// };


const clearEmailFields = () => {
  setEmail("");
  setValue("Email", "");
};

const handleStudentEmailExists = (emailVal) => {
  swal({
    text: `The email ${emailVal} is already registered in our system. Would you like to Use the existing data on system or Register again with new details.`,
    icon: "warning",
    closeOnClickOutside: false,
    buttons: {
      cancel: "Enter New Details",
      confirm: "Use Existing Data",
    },
  }).then((res) => {
    if (res) {
      regonSubmit(emailVal);
      clearEmailFields();
    } else {
      clearEmailFields();
      setEmailExists(null);
    }
  });
};

const handleNonStudentEmailExists = () => {
  swal({
    text: `This provided email is already associated to an existing user role. Please use a different email.`,
    icon: "warning",
    closeOnClickOutside: false,
  }).then(() => {
    clearEmailFields();
  });
};

const handleEmailValidation = (e) => {
  const emailVal = e.target.value.trim();
  
  if (!ValidationPattern.email.test(emailVal)) {
    setEmailExists(null);
    return;
  }

  validateEmail(emailVal)
    .then((exists) => {
      if (exists.present) {
        if (exists.message === "Student") {
          handleStudentEmailExists(emailVal);
        } else {
          handleNonStudentEmailExists();
        }
      }
      setEmailExists(exists);
      setEmailExistsValue(exists.present);
    })
    .catch(() => {
      setEmailExists(null);
    });
};



 const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);
  setEmailExists(null);
};

  const renderEmailValidationIcon = () => {
    if (emailExistsValue === false) {
      return (
        <span className="email_valid_icon">
          <i className="fa-solid fa-check email_valid_tick"></i>
        </span>
      );
    }
    
    if (!errors?.Email && email && emailExists === false) {
      return (
        <span className="email_valid_icon">
          <i className="fa-solid fa-check email_valid_tick"></i>
        </span>
      );
    }
    
    return null;
  };

  const renderGenderField = () => {
    if (gender === "") {
      return (
        <SelectElement
          {...useFromProps}
          clearable
          divClassName={divClassNameSelectElement}
          readOnly={false}
          registerName={"Gender"}
          mandatory={true}
          labelName={"Gender"}
          options={uploadedDocs}
          onSelect={(value) => {
            trigger("Gender");
          }}
          onChange={() => {}}
          errorLabel="Please Select valid Gender"
        />
      );
    }
    
    return (
      <InputElement
        {...useFromProps}
        divClassName={divClassNameSelectElement}
        useForm={useForm}
        readOnly={true}
        type="text"
        labelName="Gender"
        sublabelName=""
        mandatory={true}
        registerName={"Gender"}
        name={"Gender"}
        onChange={() => { }}
        errorLabel="Please Select valid Gender"
      />
    );
  };

  const renderRegistrationForm = () => {
    if (selectedTab === "AlreadyRegistered") {
      return (
        <>
          <div className="row">
            <InputElement
              {...useFromProps}
              divClassName={divClassName}
              useForm={useForm}
              readOnly={false}
              type="text"
              labelName="Registered Email"
              sublabelName=""
              pattern={{
                value: ValidationPattern.email,
                message: "Please enter valid Email",
              }}
              registerName={"RegEmail"}
              name={"RegEmail"}
              mandatory={mandatory}
              onPaste={false}
              onCopy={false}
              onChange={(event) => { }}
              errorLabel="Please enter valid Email"
            />
          </div>
          <button
            className="w-100 text-center Reg_Button mt-3"
            onClick={handleSubmit(regonSubmit)}
          >
            Submit
          </button>
        </>
      );
    }
    
    return (
      <>
        <div className="email_sec cstm_email_sec">
          <InputElement
            {...useFromProps}
            divClassName={divClassName}
            useForm={useForm}
            type="text"
            labelName="Email"
            sublabelName=""
            pattern={{
              value: ValidationPattern.email,
              message: "Please enter valid Email",
            }}
            registerName={"Email"}
            name={"Email"}
            mandatory={mandatory}
            onPaste={false}
            onCopy={false}
            onBlur={handleEmailValidation}
            onChange={handleEmailChange}
            errorLabel="Please enter valid Email"
          />
          {renderEmailValidationIcon()}
        </div>

        <div className="second_form">
          <div className="row mt-3">
            <InputElement
              {...useFromProps}
              divClassName={divClassName}
              useForm={useForm}
              readOnly={name === "" ? false : true}
              type="text"
              labelName="Participant Name"
              sublabelName=""
              pattern={{
                value: ValidationPattern.name,
                message: "Please enter valid name",
              }}
              registerName={"ParticipantName"}
              name={"ParticipantName"}
              mandatory={mandatory}
              onPaste={false}
              onCopy={false}
              onChange={(event) => { }}
              errorLabel="Please enter valid name"
            />

            <InputElement
              {...useFromProps}
              divClassName={divClassName}
              useForm={useForm}
              readOnly={mobile === "" ? false : true}
              type="text"
              labelName="Mobile"
              sublabelName=""
              pattern={{
                value: ValidationPattern.mobile,
                message: "Please enter valid Mobile",
              }}
              registerName={"Mobile"}
              name={"Mobile"}
              mandatory={mandatory}
              onPaste={false}
              onCopy={false}
              onChange={(event) => { }}
              errorLabel="Please enter valid Mobile"
            />

            <SelectElement
              {...useFromProps}
              clearable
              divClassName={divClassName}
              readOnly={false}
              registerName={"occupation"}
              mandatory={false}
              labelName={"Occupation"}
              options={occupationsList}
              onSelect={(value) => {
                trigger("occupation");
              }}
              onChange={() => {}}
              errorLabel="Please Select valid Occupation"
            />

            <InputElement
              maxLength={2}
              {...useFromProps}
              divClassName={divClassName}
              useForm={useForm}
              readOnly={false}
              type="text"
              labelName="Age"
              sublabelName=""
              pattern={{
                value: ValidationPattern.age,
                message: "Please enter a valid age",
              }}
              registerName={"age"}
              name={"age"}
              mandatory={mandatory}
              onPaste={false}
              onCopy={false}
              onChange={(event) => { }}
              errorLabel="Please enter a valid age"
            />

            <InputElement
              {...useFromProps}
              divClassName={divClassNameSelectElement}
              useForm={useForm}
              readOnly={false}
              type="text"
              labelName="Pincode"
              sublabelName=""
              pattern={{
                value: ValidationPattern.pin,
                message: "Please enter valid PIN code",
              }}
              registerName={"PINcode"}
              name={"PINcode"}
              mandatory={mandatory}
              onPaste={false}
              onCopy={false}
              onChange={(event) => { }}
              errorLabel="Please enter valid  PIN code."
            />

            {renderGenderField()}
          </div>
        </div>

        <div className="disclaimer">
          <div className="form-check">
            <input
              className="form-check-input cstm_check"
              type="checkbox"
              id="idDisclaimer"
              {...register("disclaimer")}
              defaultChecked={true}
            />
            <label className="form-check-label" htmlFor="idDisclaimer">
              By continuing, I agree to receive updates and communications from BSE India (you may uncheck to opt out).
            </label>
          </div>
        </div>

        <button
          className={!confirmationMsg ? "w-100 text-center Reg_Button mt-3" : "w-100 text-center Reg_Button mt-3 disabled"}
          onClick={handleSubmit(onSubmit)}
        >
          {!confirmationMsg ? "Register" : setLoading(true)}
        </button>
      </>
    );
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="usp_main">
            <div className="container-lg my-5">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6 d-flex justify-content-around m-auto">
                  <Eventscard storeData={uspTemData} page={"reg"} />
                </div>
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="w-100 text-center Reg_div mb-2">
                    Registration
                  </div>

                  {/* <div className="event_type_btn mb-5">
                    <button
                      type="button"
                      className={
                        selectedTab == "NewRegistered"
                          ? "Register_button_both w-50"
                          : "event_type_tab w-50"
                      }
                      onClick={() => handleEventType("NewRegistered")}
                    >
                      {" "}
                      {selectedTab == "NewRegistered" ? (
                        <img src={delf_icon} />
                      ) : (
                        <img src={both_icon} />
                      )}{" "}
                      New User{" "}
                    </button>
                    <button
                      type="button"
                      className={
                        selectedTab == "AlreadyRegistered"
                          ? "Register_button_both reg_border w-50"
                          : "event_type_tab reg_border w-50"
                      }
                      onClick={() => handleEventType("AlreadyRegistered")}
                    >
                      {" "}
                      {selectedTab == "AlreadyRegistered" ? (
                        <img src={delf_icon} />
                      ) : (
                        <img src={both_icon} />
                      )}{" "}
                      Existing User{" "}
                    </button>
                  </div> */}

                  {renderRegistrationForm()}
                </div>
              </div>
            </div>
          </div>

          <Modal
            Modal
            size="l"
            show={showScannerModal}
            onHide={handleClose}
            // fullscreen={true}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              {openQr && <QRScanner onSubmit={qrCodeSuccessCallback} />}

              <div className="card cardStyle"></div>
              {/* <div className='text-center my-5'><h4>{confirmationMsg}</h4></div> */}
            </Modal.Body>
          </Modal>
        </>
      )}
    </React.Fragment>
  );
};

export default Registration;
